import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';

import { LoginData } from '../entities/login-data';
import { RegisterData } from '../entities/register-data';

import * as AuthActions from './auth.actions';
import * as AuthSelectors from './auth.selectors';

@Injectable()
export class AuthFacade {
    private readonly store = inject(Store);
    private readonly router = inject(Router);

    readonly isAuthenticated$ = this.store.select(AuthSelectors.selectIsAuthenticated);
    readonly loading$ = this.store.select(AuthSelectors.selectLoading);
    readonly error$ = this.store.select(AuthSelectors.selectError);
    readonly account$ = this.store.select(AuthSelectors.selectAccount);
    readonly accountInitiallyRequested$ = this.store.select(AuthSelectors.selectAccountInitiallyRequested);
    readonly urlAfterLogin$ = this.store.select(AuthSelectors.selectUrlAfterLogin);

    navigateToLogin(url: string) {
        this.store.dispatch(AuthActions.navigateToLogin({ url }));
        this.router.navigate(['authorization', 'login']);
    }

    authenticate(data: LoginData): void {
        this.store.dispatch(AuthActions.authenticate(data));
    }

    register(data: RegisterData): void {
        this.store.dispatch(AuthActions.register(data));
    }

    checkAuthentication(): void {
        this.store.dispatch(AuthActions.checkAuthentication());
    }

    setToken(token: string): void {
        this.store.dispatch(AuthActions.setToken({ token }));
    }

    setIsAuthenticated(isAuthenticated: boolean): void {
        this.store.dispatch(AuthActions.setIsAuthenticated({ isAuthenticated }));
    }

    accountInitiallyRequested(): void {
        this.store.dispatch(AuthActions.accountInitiallyRequested());
    }

    logout(url: string): void {
        this.store.dispatch(AuthActions.logout());
        this.navigateToLogin(url);
    }
}
